export const DELAY_COURSE_CARD_QUICK_VIEW_BOX = 'delay_course_card_quick_view_box';
export const HIDE_WISHLIST_BUTTON_ON_COURSE_CARD_QUICK_VIEW_BOX =
    'hide_wishlist_button_on_course_card_quick_view_box';
export const COURSE_CARDS_OPEN_IN_NEW_TAB = 'course_cards_open_in_new_tab';
export const LOCALE_SPECIFIC_TOPICS = 'locale_specific_topics';
export const COURSE_GUIDANCE_FEATURE = 'course_guidance_feature';
export const USER_STREAKS_ON_MX_LIHP = 'user_streaks_on_mx_lihp';
export const DESKTOP_POST_ADD_TO_CART_BEHAVIOR = 'desktop_post_add_to_cart_behavior';
export const CERTIFICATION_BUNDLE_UNIT_LIHP = 'certification_bundle_unit_lihp';
export const NEW_SEARCH_BAR_MX = 'new_search_bar_mx';
export const PERSONAL_PLAN_COURSE_ENROLLMENT = 'personal_plan_course_enrollment';
export const CART_LOGINSIGNUP_REDIRECT_TO_CHECKOUT = 'cart_loginsignup_redirect_to_checkout';
export const FBT_FORCE_GO_TO_CART = 'fbt_force_go_to_cart';
export const LIHP_CERT_VOUCHER_RECO_BANNER = 'lihp_cert_voucher_reco_banner';
export const TOP_10_COURSES_JAPAN = 'top_10_courses_japan';
export const VALUE_PLAN_STARTER_PLAN = 'value_planstarter_plan';
export const VALUE_PLAN_UPSELL = 'starter_plan_upsell';
export const PP_PRODUCT_GUIDE_EXPERIENCE = 'pp_product_guide_experience';
export const JBI_ENHANCED_LECTURE_UNIT = 'jbi_enhanced_lecture_unit';
export const SHOW_AT_RISK_FEEDBACK_SURVEY = 'show_at_risk_feedback_survey';
export const VERTICAL_SCROLL_RECO_UNITS_MOBILE_LIHP = 'vertical_scroll_reco_units_mobile_lihp';
export const FBT_BUNDLE_SERVICE_VOUCHERS = 'fbt_bundle_service_vouchers';
export const PP_MODULE_POSITIONING = 'pp_module_positioning';
export const LIHP_CAROUSEL_HOVER_POPUP_REMOVAL = 'lihp_carousel_hover_popup_removal';

export type JbiEnhancedLectureVariant = 'control' | 'video' | 'curriculum' | 'summary';
